module.exports = __webpack_public_path__ + "img/setting.407e25c6.png";